/**
 * authSession.js — burimi i vetëm i së vërtetës për sesionin e hyrjes.
 *
 * Sesioni shkruhet VETËM nga sessionPersistence.js → helper().setItem():
 *   • "Më mbaj mend" / Electron → cookie
 *   • web i zakonshëm           → sessionStorage
 * Nuk shkruhet KURRË në localStorage. Çdo lexim nga localStorage kthen null,
 * që do të thotë token bosh → asnjë header Authorization → 401.
 *
 * Përdore këtë modul në vend që të kopjosh getAuthHeaders() nëpër komponentë:
 * pikërisht ai duplikim e shkaktoi rastin ku moduli i prezencës lexonte
 * localStorage dhe dërgonte kërkesa pa autentifikim.
 */

const SESSION_KEY = 'logedInUser';

function readFromSessionStorage() {
  try {
    return sessionStorage.getItem(SESSION_KEY) || '';
  } catch {
    return '';
  }
}

function readFromCookie() {
  try {
    const cookie = document.cookie
      .split(';')
      .find((c) => c.trim().startsWith(`${SESSION_KEY}=`));
    if (!cookie) return '';
    return decodeURIComponent(cookie.split('=').slice(1).join('='));
  } catch {
    return '';
  }
}

/** Përdoruesi i kyçur, ose {} nëse s'ka sesion. Kurrë nuk hedh gabim. */
export function getLogedInUser() {
  const raw = readFromSessionStorage() || readFromCookie();
  if (!raw) return {};
  try {
    return JSON.parse(raw) || {};
  } catch {
    return {};
  }
}

/** Access token-i i sesionit, ose '' nëse s'ka. */
export function getAuthToken() {
  return getLogedInUser()?.token || '';
}

/** Header-at Authorization, ose {} nëse s'ka token (si më parë). */
export function getAuthHeaders() {
  const token = getAuthToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
}

/**
 * Emri i përdoruesit për shfaqje / gjurmë auditimi (p.sh. ReviewedBy).
 *
 * loginService ruan `data: { firstname, lastname, username, email }` — NUK ka
 * fushë `name`. Prandaj `u.data.name` është gjithmonë undefined dhe thirrësit
 * binin te fallback-u ('Admin'), duke fshehur se kush e kreu veprimin.
 *
 * @param {string} fallback vlera kur s'ka sesion
 */
export function getUserDisplayName(fallback = '') {
  const u = getLogedInUser();
  const d = u?.data || u;
  if (!d) return fallback;
  const full = [d.firstname || d.first_name, d.lastname || d.last_name]
    .filter(Boolean)
    .join(' ')
    .trim();
  return full || d.name || d.username || d.email || fallback;
}

export default { getLogedInUser, getAuthToken, getAuthHeaders, getUserDisplayName };
